import { type RPPDomain } from '@retailer-platform/dashboard/core'

import { ippNavIntrospectAdminRouter } from './routing/ippNavIntrospectAdminRouter'

import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'ipp-nav-introspect',
  routes,
  translations: {},
  lazyTranslations: {
    EN_US: () => import('./translations/en-US.json'),
    // Uncomment to lazy load your domain's foreign dictionaries
    // ES_ES: () => import('./translations/es-ES.json'),
    // FR_FR: () => import('./translations/fr-FR.json'),
  },
  routers: {
    admin: [ippNavIntrospectAdminRouter],
  },
  navigationEntries: [],
  adminNavigationEntries: [],
  totem: {
    tool: 'ipp-nav-introspect',
  },
}

export default definition
